import "./style.css"
import { SKILLS } from "../../data/skills.js"
import { ACHIEVEMENTS } from "../../data/achievements.js"

<div class="section-container">
  <if=input.isPage>
    <h2>About Me</h2>
  </if>
  <else>
    <h3>About Me</h3>
  </else>

  <div class="about-sections">

    <!-- Background -->
    <div class="about-section">
      <div class="about-section-accent"/>
      <div class="about-section-content">
        <h4 class="about-section-title">Background</h4>
        <p>
          I am originally from Jacksonville, Florida. Growing up, I was a Boy Scout and
          earned the rank of <span class="emphasize">Eagle Scout</span>. I graduated
          from Johnson &amp; Wales University in 2019 with Associates' degrees in
          Culinary Arts and Baking &amp; Pastry, plus a
          <span class="emphasize">Bachelor's in Entrepreneurship</span>. This background
          led me to work with restaurants and breweries in the Charlotte area. I began
          teaching myself to code in 2020, making heavy use of freeCodeCamp and LinkedIn
          Learning. Aside from coding, I enjoy cooking and baking, watching documentaries
          and anime, playing video games, and spending time with my family.
        </p>
      </div>
    </div>

    <!-- Career -->
    <div class="about-section">
      <div class="about-section-accent"/>
      <div class="about-section-content">
        <h4 class="about-section-title">Career</h4>
        <p>
          My first Software Developer role was with
          <span class="emphasize">GoTab</span> (May 2021 – present), where I work as
          a <span class="emphasize">Software Developer II</span>. At GoTab I own the
          gift card infrastructure, and have delivered meaningful business impact
          including Twilio fraud prevention saving roughly
          <span class="emphasize">$32k/month</span> and CTIA-compliant SMS
          implementation saving around
          <span class="emphasize">$5k/month</span>. I have written integrations for
          <span class="emphasize">5 major Restaurant POS/KDS systems</span> and
          interfaced the web app with a
          <span class="emphasize">Thermal Receipt Printer over USB</span>.
        </p>
        <p>
          My full-stack work spans
          <span class="emphasize">Marko.js, Node.js, Python, AWS Lambda,</span> and
          <span class="emphasize">Aurora PostgreSQL</span>. GoTab's large and complex
          database has greatly deepened my understanding of
          <span class="emphasize">SQL and PLPGSQL</span>.
        </p>
        <p>
          Prior to GoTab, I worked with
          <span class="emphasize">Freshlist</span> where I used HTML and CSS to style
          Shopify order slips, prototyped an Instagram follower counter with Python and a
          Raspberry Pi, and built a full-stack recipe search app with an Express API and
          PostgreSQL database.
        </p>
      </div>
    </div>

    <!-- Skills -->
    <div class="about-section">
      <div class="about-section-accent"/>
      <div class="about-section-content">
        <h4 class="about-section-title">Skills</h4>
        <div class="skills-grid">
          <for|entry| of=Object.entries(SKILLS)>
            <div class="skill-category">
              <span class="skill-category-label">${entry[0]}</span>
              <div class="skill-tags">
                <for|skill| of=entry[1]>
                  <span class="skill-tag">${skill}</span>
                </for>
              </div>
            </div>
          </for>
        </div>
      </div>
    </div>

    <!-- Achievements -->
    <!--
    <div class="about-section">
      <div class="about-section-accent"/>
      <div class="about-section-content">
        <h4 class="about-section-title">Recent Achievements</h4>
        <ul class="achievements-list">
          <for|achievement| of=ACHIEVEMENTS>
            <li class="achievement-item">
              <span class="achievement-icon">${achievement.icon}</span>
              <span>${achievement.label}</span>
            </li>
          </for>
        </ul>
      </div>
    </div>
    -->

  </div>
</div>
